import { FC, lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { PageSpinner } from 'src/components/spinner-container';
import { usePlatformSettings } from 'src/pages/reporting/auctions/use-platform-settings';
import { ExternalTradesEntry } from 'src/pages/reporting/secondary-tradings/external-trades';
import { useHasExternalTrades } from 'src/pages/reporting/secondary-tradings/overview/use-has-external-trades';
import {
  remitReportingSubscriptionInfoLoading,
  useRemitReportingSubscriptionInfo,
} from 'src/pages/reporting/secondary-tradings/overview/use-remit-reporting-subscription-info';

const Page = lazy(() => import('./page'));

export const ReportingSecondaryTradings: FC = () => {
  const platformSettings = usePlatformSettings();
  const hasExternalTrades = useHasExternalTrades();
  // precaching subscription info
  const subscriptionInfoRequest =
    useRemitReportingSubscriptionInfo('SECONDARY');

  if (
    !platformSettings.loaded ||
    !hasExternalTrades.loaded ||
    remitReportingSubscriptionInfoLoading(subscriptionInfoRequest)
  ) {
    return <PageSpinner />;
  }

  return (
    <Switch>
      <Route
        path={[
          '/reporting/secondary',
          '/reporting/secondary/trades',
          '/reporting/secondary/external',
          '/reporting/secondary/external-trades',
          '/reporting/secondary/proposals',
          '/reporting/secondary/remit-reporting',
        ]}
        exact
      >
        <Page
          platformSettings={platformSettings}
          hasExternalTrades={hasExternalTrades}
        />
      </Route>
      <Route path="/reporting/secondary/external-trades/*">
        <ExternalTradesEntry />
      </Route>
    </Switch>
  );
};
